'use strict';
const angular = require('angular');

export class menuEntryEditComponent {
  constructor(Config, EFormsService, SurveysService, DynamicPageService) {
    'ngInject';
    this.roles = Config.getPlatformConfig().getPermissionRoles();

    this.node = {id:'none'};
    this.config = {};

    this.treeOptions = {
      nodeChildren: "children",
      dirSelectable: false,
      injectClasses: {
        ul: "a1",
        li: "a2",
        liSelected: "a7",
        iExpanded: "a3",
        iCollapsed: "a4",
        iLeaf: "a5",
        label: "a6",
        labelSelected: "a8"
      }
    };

    this.settings = {
      'dir.directory': ["lorem","ipsum", "dolor"], // <-- must be fetched from settings (tag settings??)
      'calendar': Config.getModuleConfig(Config.Modules.Calendar).getEventTypes(),
      'news': Config.getModuleConfig(Config.Modules.News).getTypes(),
      'gallery': Config.getModuleConfig(Config.Modules.Gallery).getTypes(),
      'reservation': Config.getModuleConfig(Config.Modules.Reservation).getTypes(),
      'document.page': [],
      'eform': [],
      'survey': []
    };
    let documentPageCategories = Config.getModuleConfig(Config.Modules.Document).getPageCategories();
    if (documentPageCategories) {
     this.settings['document.page'] = Object.keys(documentPageCategories);
    }

    EFormsService.query(data => {
      this.settings['eform'] = data.map(eform => { return {name: eform.name, id: eform._id}; })
    });

    SurveysService.query(data => {
      this.settings['survey'] = data.map(survey => { return {name: survey.name, id: survey._id}; })
    });

    DynamicPageService.query(data => {
      if (this.public) {
        this.settings['misc.page'] = data.filter(page => page.isPublic).map(page => page.name);
      } else {
        this.settings['misc.page'] = data.map(page => page.name);
      }
    });

    this.updateURL = id => {
      switch(id) {
        case 'dir.directory':
          if (this.public) {
            this.menuEntry.url = "/public/directory/" + this.config.dirDirectory;
          } else {
            this.menuEntry.url = "/directory/" + this.config.dirDirectory;
          }
          break;
        case 'calendar':
          this.menuEntry.url = "/calendar/"+ this.config.calendar +"/list";
          break;
        case 'news':
          this.menuEntry.url = "/"+ this.config.news +"/list";
          break;
        case 'gallery':
          if (this.public) {
            this.menuEntry.url = "/public/gallery/list/"+ this.config.gallery;
          } else {
            this.menuEntry.url = "/gallery/list/"+ this.config.gallery;
          }
          break;
        case 'document.page':
          if (this.public) {
            this.menuEntry.url = "/public/document/" + this.config.documentPage;
          } else {
            this.menuEntry.url = "/document/" + this.config.documentPage;
          }
          break;
        case 'reservation.list':
          this.menuEntry.url = "/reservation/"+ this.config.reservation +"/list";
          break;
        case 'reservation.admin':
          this.menuEntry.url = "/reservation/"+ this.config.reservation +"/admin";
          break;
        case 'eform.browser':
          this.menuEntry.url = "/e-form/responses/"+ this.config.eform;
          break;
        case 'eform':
          this.menuEntry.url = "/e-form/"+ this.config.eform;
          break;
        case 'survey.result':
          this.menuEntry.url = "/admin/survey/results/"+ this.config.survey;
          break;
        case 'survey':
          this.menuEntry.url = "/survey/"+ this.config.survey;
          break;
        case 'misc.page':
          if (this.public) {
            this.menuEntry.url = "/public/page/" + this.config.dynamicPage;
          } else {
            this.menuEntry.url = "/page/"+ this.config.dynamicPage;
          }
          break;
        default:
          this.menuEntry.url = this.idUrlMap[id];
          break;
      }
    };
  }

  $onInit = function () {
    this.config = this.resolve.config;
    this.menuEntry = this.config.menuEntry;
    this.public = this.config.public;
    
    if (this.public) {
      this.linkCategories = [
        { "id": "eform", "name" : "E-Form", "description" : "An eform on the public page", "children" : [] },
        { "id": "dir.directory", "name" : "Generic Person Directory", "description" : "An directory with name, function, a profile image, contact information and a short description. Possible use-cases include Board of Directories and Staff.", "children" : [] },
        { "id": "misc.shop", "name": "Shop", "description": "Shop", children:[]},
        { "id": "misc.page", "name": "Dynamic Page", "description": "Shop", children:[]},
        {
          "name": "Document", "description":"Lorem",
          "children": [
            { "id": "document.all", "name" : "All Documents", "description" : "A list of all documents", "children" : [] },
            { "id": "document.page", "name" : "Document Page", "description" : "A list of selected document categories", "children" : [] }
          ]
        },
        {
          "name" : "Bulletin Board", "description":"Lorem ipsum",
          "id": "bulletin",
          "children" : []
        },
        {
          "name" : "Gallery", "description":"Lorem ipsum",
          "id": "gallery",
          "children" : []
        }
      ];
      this.idUrlMap = {
        "bulletin": "/public/bulletin",
        "document.all": "/public/document/list",
        "misc.shop": "/shop"
      };
    } else {
      this.linkCategories = [
        {
          "name" : "Directories", "description":"Lorem ipsum",
          "children" : [
            { "id": "dir.numbers", "name" : "Important Numbers", "description" : "A list with important numbers", "children" : [] },
            { "id": "dir.users", "name" : "User Directory", "description" : "A directory with all the registered users and their profiles", "children" : [] },
            { "id": "dir.businesses", "name" : "Business Directory", "description" : "A directory with all the resident business profiles which have been created by the users", "children" : [] },
            { "id": "dir.vendors", "name" : "Preferred Vendors List", "description" : "An admin created and managed directory of vendors", "children" : [] },
            { "id": "dir.directory", "name" : "Generic Person Directory", "description" : "An directory with name, function, a profile image, contact information and a short description. Possible use-cases include Board of Directories and Staff.", "children" : [] }
          ]
        },
          {
            "name" : "Calendar", "description":"Lorem ipsum",
            "id": "calendar",
            "children" : []
          },
          {
            "name" : "News", "description":"Lorem ipsum",
            "id": "news",
            "children" : []
          },
          {
            "name" : "Reservation", "description":"Lorem ipsum",
            "children" : [
              { "id": "reservation.list", "name" : "Reservation", "description" : "The users reservation view", "children" : [] },
              { "id": "reservation.admin", "name" : "Review", "description" : "The admins reservation review", "children" : [] }
            ]
          },
          {
            "name": "Document", "description":"Lorem",
            "children": [
              { "id": "document.all", "name" : "All Documents", "description" : "A list of all documents", "children" : [] },
              { "id": "document.page", "name" : "Document Page", "description" : "A list of selected document categories", "children" : [] }
            ]
          },
          {
            "name": "Gate Clearance", "description":"Lorem",
            "children": [
              { "id": "piper.guests", "name" : "Guests", "description" : "A list of guests", "children" : [] },
              { "id": "piper.permanent", "name" : "Permanent List", "description" : "A user's permanent guest list", "children" : [] },
              { "id": "piper.temporary", "name" : "Temporary List", "description" : "A user's temporary or expected guest list", "children" : [] }
            ]
          },
          {
            "name" : "Bulletin Board", "description":"Lorem ipsum",
            "id": "bulletin",
            "children" : []
          },
          {
            "name" : "Gallery", "description":"Lorem ipsum",
            "id": "gallery",
            "children" : []
          },
          {
            "name" : "Forum", "description":"Lorem ipsum",
            "children": [
              { "id": "forum.all", "name" : "Forum Overview", "description" : "A list of all documents", "children" : [] },
              { "id": "forum.category", "name" : "Specific Forum", "description" : "A list of selected document categories", "children" : [] }
            ]
          },
          {
            "name" : "E-Form", "description":"Lorem ipsum",
            "children": [
              { "id": "eform", "name" : "E-Form", "description" : "An eform itself where a user can type in data", "children" : [] },
              { "id": "eform.list", "name" : "List", "description" : "A list of all available eforms", "children" : [] },
              { "id": "eform.edit", "name" : "Editor", "description" : "An eform editor", "children" : [] },
              { "id": "eform.browser", "name" : "Responses", "description" : "An eform response / data browser", "children" : [] }
            ]
          },
          {
            "name" : "Survey", "description":"Lorem ipsum",
            "children": [
              { "id": "survey", "name" : "Survey", "description" : "An survey itself where a user can type in data", "children" : [] },
              { "id": "survey.list", "name" : "List", "description" : "A list of all available surveys", "children" : [] },
              { "id": "survey.edit", "name" : "Editor", "description" : "Survey editor", "children" : [] },
              { "id": "survey.result", "name" : "Result", "description" : "Survey result overview", "children" : [] }
            ]
          },
          {
            "name" : "Admin", "description":"Lorem ipsum",
            "children": [
              { "id": "admin.dashboard", "name" : "Admin Dashboard", "description" : "An admin dashboard", "children" : [] },
              { "id": "admin.user", "name" : "User List", "description" : "An admin dashboard", "children" : [] },
              { "id": "admin.slider", "name" : "Slider Editor", "description" : "An admin dashboard", "children" : [] },
              { "id": "admin.menu", "name" : "Menu Editor", "description" : "An admin dashboard", "children" : [] }
            ]
          },
          {
            "name": "Misc", "description": "",
            "children": [
              { "id": "realtor.listing", "name" : "Realtor Listings", "description" : "A list of properties by realtor", "children" : [] },
              { "id": "misc.download", "name" : "Download", "description" : "A download link", "children" : [] },
              { "id": "misc.memory", "name" : "Memory Game", "description" : "A memory game with leader board", "children" : [] },
              { "id": "ms.service", "name": "Service Requests", "description": "Management Suite Service Request Integrations", children:[]},
              { "id": "misc.shop", "name": "Shop", "description": "Shop", children:[]},
              { "id": "misc.page", "name": "Dynamic Page", "description": "Shop", children:[]}
            ]
          }
        ];
      this.idUrlMap = {
        "dir.numbers": "/important-numbers",
        "dir.users": "/user/directory",
        "dir.businesses": "/business/directory",
        "dir.vendors": "/vendor/list",
        "bulletin": "/bulletin/list",
        "misc.memory": "/game/memory",
        "forum.all": "/forum",
        "piper.guests": "/piper/guest/list",
        "piper.permanent": "/piper/permanent/list",
        "piper.temporary": "/piper/temporary/list",
        "realtor.listing": "/realtor/bulletin",
        "document.all": "/document/list",
        "ms.service": "/service-requests/list",
        "eform.edit": "/e-form/edit/",
        "eform.list": "/e-form/list/",
        "admin.dashboard": "/admin/dashboard",
        "admin.user": "/admin/users",
        "survey.list": "/admin/survey/list",
        "survey.edit": "/admin/survey/edit/",
        "admin.slider": "/admin/slider-editor",
        "admin.menu": "/admin/menu-editor",
        "misc.shop": "/shop"
      };
    }

  };

  ok() {
    this.close({$value: this.menuEntry});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }


}

export default angular.module('conduApp.menuEntryEdit', [])
  .component('menuEntryEdit', {
    template: require('./menu-entry-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: menuEntryEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/menu-entry-edit/menu-entry-edit.component.js